<template>
    <div class="file-list-item" :class="file.displayClasses">
        <a href="#" @click.prevent="clickHandler">
            <div class="file-list-item-icon-wrapper">
                <div class="file-list-item-icon" :style="thumbnailBackgroundImage()">
                    <i v-if="!this.file.thumbnailUrl" class="font-icon" :class="thumbnailBackgroundIcon()"></i>
                    <div class="file-list-item-busy-courtain" v-if="isBusy"></div>
                </div>
            </div>
        </a>

        <div class="file-list-item-info" :class="isBusy ? 'justify-center' : 'justify-between'">
            <div v-if="isBusy">
                <span><i class="fa fa-spinner fa-spin"></i> {{ busyMessage }}</span>
            </div>
            <template v-else>
                <div class="file-list-item-name">
                    <a href="#" @click.prevent="clickHandler">{{file.name}}.{{file.ext}}</a>
                </div>
                <div class="file-list-item-extra" v-if="file.size > 0">
                    <span>{{ file.size | size }}</span>
                </div>
            </template>
        </div>

        <div class="file-list-item-actions">
            <slot name="actions"></slot>
        </div>

    </div>
</template>

<script>
export default {
    name: 'MediaItem',
    props: {
        file: {
            type: Object,
            default: () => ({})
        },
        locale: {
            type: String,
            default: 'pl'
        },
        onClick: {
            type: Function,
            required: true
        }
    },
    computed: {
        isBusy() {
            return this.file.isBusy || this.file.isFetchingInfo || this.file.isDownloading
        },
        busyMessage() {
            if (this.file.busyMessage !== '') {
                return this.file.busyMessage;
            }
            if (this.file.isFetchingInfo) {
                return this.t('fetching_info');
            }
            if (this.file.isDownloading) {
                return this.t('fetching_file');
            }
            return '';
        },
        translations() {
            return {
                pl: {
                    fetching_info: 'Trwa pobieranie informacji o pliku...',
                    fetching_file: 'Trwa pobieranie pliku...',
                },
                en: {
                    fetching_info: 'Fetching file information...',
                    fetching_file: 'Fetching file...',
                }
            }
        }
    },
    methods: {
        clickHandler() {
            if (this.isBusy) {
                return;
            }
            this.onClick(this.file);
        },

        thumbnailBackgroundImage() {
            if (this.file.thumbnailUrl) {
                return `background-image: url("${this.file.thumbnailUrl}")`
            }
            return ''
        },

        thumbnailBackgroundIcon() {
            if (this.file.isImage()) {
                return 'fa fa-file-image-o';
            }
            let iconClass = 'fa fa-file-o';

            switch (this.file.ext) {
                case 'pdf':
                    iconClass = 'fa fa-file-pdf-o';
                    break;
                case 'doc':
                case 'docx':
                case 'odt':
                    iconClass = 'fa fa-file-word-o';
                    break;
                case 'xls':
                case 'xlsx':
                case 'ods':
                    iconClass = 'fa fa-file-excel-o';
                    break;
            }
            return iconClass;
        },

        t(key) {
            if (this.translations[this.locale] && this.translations[this.locale][key]) {
                return this.translations[this.locale][key];
            }
            return key;
        }
    },

    filters: {
        size(size) {
            return `${Math.round(size / 1000 * 100) / 100} kB`;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>